const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefreshed: 'section-refreshed',
};

const SECTION_REFRESH_RESOURCE_TYPE = {
  product: 'product',
};

function updateWashClubDirectionLinks() {
  const linkSelectors = [
    'a.zuwc-btn[href="/pages/mentor-mentor-ave-car-wash-menu"]',
    'a.zuwc-btn[href="/pages/chardon-center-st-car-wash-menu"]',
  ];

  linkSelectors.forEach((selector) => {
    const link = document.querySelector(selector);
    if (!link) return;

    link.setAttribute('href', '/pages/locations');
    link.textContent = 'Get Directions';
  });
}

if (window.location.pathname.replace(/\/$/, '') === '/pages/unlimited-wash-club') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWashClubDirectionLinks, { once: true });
  } else {
    updateWashClubDirectionLinks();
  }
}
